export default "__VITE_ASSET__B_mP$zwR__"